/**
 * Database table names used in the HR module.
 *
 * @readonly
 * @enum {string}
 */
export const HR_TABLES = {
  USER: 'user',
  USERS: 'users',
  USER_HEALTH: 'user_health',
  USER_CONTRACTS: 'user_contracts',
  USER_WORK_CLOTHES: 'user_work_clothes',
  USER_FAMILY_MEMBERS: 'user_family_members',
};

/**
 * Colour codes for HR profiles.
 *
 * @readonly
 * @enum {string}
 */
export const HR_PROFILES_COLORS = {
  employee: '#70CA44',
};

/**
 * Categories of documents in the HR module.
 *
 * @readonly
 * @enum {string}
 */
export const HR_DOCUMENT_CATEGORIES = {
  HEALTH: 'Health',
  CONTRACT: 'Contract',
  PROFILE_PHOTO: 'Photo',
  OFFICIAL_INFORMATION: 'Official Information',
};

/**
 * Statuses for HR documents.
 *
 * @readonly
 * @enum {string}
 */
export const HR_DOCUMENT_STATUSES = {
  SIGNED: 'signed',
  NOT_SIGNED: 'not_signed',
  NOT_REQUIRED: 'not_required',
  NEEDS_SIGNATURE: 'needs_signature',
  PENDING_SIGNATURE: 'pending_signature',
};

/**
 * User groups related to HR module with their respective identifiers.
 *
 * @enum {string}
 */
export const HR_GROUPS = {
  ADMIN: 'employee_management_admin',
  VIEWER: 'employee_management_viewer',
  CLOTHS: 'clothes_sizes_admin',
  CONTRACT: 'team_contract_viewer',
  FINANCE: 'finance_viewer', // TODO:: add
};

/**
 * Color codes representing different health check statuses.
 *
 * Keys indicate the timing/status of the health check.
 */
export const HEALTH_STATUS_COLORS = {
  finished: '#70CA44',
  nextmonth: '#FFD54F',
  nextweek: '#FFB74D',
  thismonth: '#FB8C00',
  thisweek: '#E64A19',
  upcoming: '#FFE082',
};

/**
 * Reoccurrence intervals for health checks.
 *
 * Values represent the unit of recurrence for scheduling next health checks.
 */
export const HEALTH_CHECK_REOCCURRENCE: { [key: string]: string } = {
  DAYS: '1_days',
  WEEKS: '2_weeks',
  MONTHS: '3_months',
  YEARS: '4_years',
};
